import { StringUtil, WindowTitleProvider } from "@mcleod/core";
import { LMEUserSettings } from "./settings/LMEUserSettings";

export class LMEWindowTitleProvider extends WindowTitleProvider{
    override finalizeTitle(title: string): string {
        const result = super.finalizeTitle(title);
        return this.appendCompanyInfo(result);
    }

    private appendCompanyInfo(title: string) {
        const settings = LMEUserSettings.get();
        let result = title;
        if (!StringUtil.isEmptyString(settings.company_id)) {
            result += " " + settings.company_id;
        }
        if (!StringUtil.isEmptyString(settings.company_name)) {
            result += " " + settings.company_name;
        }
        return result;
    }
}
